var _defineProperty = require("/opt/build/repo/frontend/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function duplicateNode(node) {
  return _objectSpread(_objectSpread({}, node), {}, {
    children: []
  });
}

function getConcatenatedValue(node) {
  if (!node) {
    return "";
  }

  if (node.type === "text") {
    return node.value;
  } else if (node.children && node.children.length) {
    return node.children.map(getConcatenatedValue).filter(function (value) {
      return value;
    }).join("");
  }

  return "";
}

function cloneTreeUntil(root, endCondition) {
  var clonedRoot;
  var endConditionMet = false;

  function preOrderTraversal(node) {
    if (endConditionMet || endCondition({
      root: clonedRoot,
      nextNode: node
    })) {
      endConditionMet = true;
      return;
    }

    var newNode = duplicateNode(node);

    if (clonedRoot) {
      clonedRoot.children.push(newNode);
    } else {
      clonedRoot = newNode;
    }

    if (node.children) {
      node.children.forEach(function (child) {
        clonedRoot = newNode;
        preOrderTraversal(child);
      });
      clonedRoot = newNode;
    }
  }

  preOrderTraversal(root);
  return {
    tree: clonedRoot,
    is_pruned: endConditionMet
  };
}

function findLastTextNode(node, textNode) {
  if (node.type === "text") {
    textNode = node;
  }

  if (node.children) {
    node.children.forEach(function (child) {
      var laterTextNode = findLastTextNode(child, textNode);

      if (laterTextNode !== textNode) {
        textNode = laterTextNode;
      }
    });
  }

  return textNode;
}

module.exports = {
  getConcatenatedValue: getConcatenatedValue,
  cloneTreeUntil: cloneTreeUntil,
  findLastTextNode: findLastTextNode
};